import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1>Potencia tus ventas con MEGALOTO</h1>
        <p>
          Únete al módulo de ventas más innovador. Gana comisiones por tus referidos y
          transforma tus ingresos. ¡Es tu oportunidad de crecimiento!
        </p>
        <a href="https://wa.me/573133956853?text=Estoy%20interesado%20en%20unirme%20al%20grupo%20de%20ventas%20de%20Megaloto,%20me%20das%20más%20informacion,%20por%20favor" className="cta-button">Descubre más</a>
      </div>
      <div className="hero-image">
        <img src="https://firebasestorage.googleapis.com/v0/b/megaloto-express.appspot.com/o/empresa%2FlogoMegaLoto.png?alt=media&token=ddc64046-fd7a-459b-9a4f-ebba7b4e8dde" alt="Módulo de ventas MEGALOTO" />
      </div>
    </section>
  );
};

export default HeroSection;
